var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonBpmnConditionalFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 2.5H7.5C7.16848 2.5 6.85054 2.6317 6.61612 2.86612C6.3817 3.10054 6.25 3.41848 6.25 3.75V36.25C6.25 36.5815 6.3817 36.8995 6.61612 37.1339C6.85054 37.3683 7.16848 37.5 7.5 37.5H32.5C32.8315 37.5 33.1495 37.3683 33.3839 37.1339C33.6183 36.8995 33.75 36.5815 33.75 36.25V3.75C33.75 3.41848 33.6183 3.10054 33.3839 2.86612C33.1495 2.6317 32.8315 2.5 32.5 2.5ZM12.5 8.75H21.25V11.25H12.5V8.75ZM27.5 30H12.5V27.5H27.5V30ZM27.5 23.75H12.5V21.25H27.5V23.75ZM27.5 17.5H12.5V15H27.5V17.5Z",
    fill: "#0D99FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonBpmnConditionalFill);
export default __webpack_public_path__ + "static/media/carbon_bpmn-conditional-fill.fdba0599fc50c84a9b83ed73a3d304c4.svg";
export { ForwardRef as ReactComponent };